import React from "react";
import {Box, Skeleton, Typography} from "@mui/material";

interface ILoaderFormProps {
	title: string;
}
export const LoaderForm: React.FC<ILoaderFormProps> = (props) => {
	return (
		<Box sx={{padding: 3}} alignSelf={"center"} width={"500px"}>
			<Typography variant="h4" component="h1" align="center" gutterBottom>
				{props.title}
			</Typography>
			<Skeleton />
			<Skeleton />
			<Skeleton />
			<Skeleton />
			<Skeleton />
			<Skeleton />
		</Box>
	);
};
